import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-593ac878"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { ref } from 'vue'
    import {useRouter} from 'vue-router'
    import {GETAuth} from '@/service/index'

    
export default /*#__PURE__*/_defineComponent({
  props: ['item', 'isShow'],
  setup(__props) {

const props = __props

    
    const item = ref(props.item)
    const router = useRouter();
    const goBoming = async () => {
        let { data }  = await GETAuth(`/common/enroll_period`, {
            params: {
                subjectcode: item.value.subjectcode,
                audiencecode: item.value.audiencecode,
                stagecode: item.value.stagecode,
                status: 1
            }
        })
        if ( data.code === 200 ) {
            if ( data.data.length < 1 ) {
                alert(`${item.value.coursename.replaceAll(' ','')}开班不足！`)
            } else {
                router.push({
                    name: 'EnrollRecord',
                    params: {
                        TrainingStage: item.value.stagecode,
                        SubjectCode:  item.value.subjectcode,
                        AudienceCode: item.value.audiencecode
                    }
                })
            }
        }
        
    }

return (_ctx: any,_cache: any) => {
  return (__props.isShow)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "card",
        onClick: goBoming
      }, [
        _createElementVNode("img", {
          src: item.value.imageurl
        }, null, 8, _hoisted_1),
        _createElementVNode("span", null, _toDisplayString(item.value.coursename), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})